//
//
//

import { apiUrl, reportUrl, cloudFunctionsUrl } from '@/constants'
import { parseJson } from '@/functions'
import axios from 'axios'

//
//
//

const isHttpCodeValid = status => [200, 201, 204, 400, 401, 403, 404, 405, 409, 422, 424, 500].includes(status)

const localResponseObj = (reason, httpCode = 0) => ({
  code: 'LOCAL',
  title: 'Erro local',
  message: `A solicitação falhou. Por favor, tente novamente ou fale com o nosso suporte. ${reason}`,
  httpCode,
})

const httpRequest = args => {
  return new Promise((resolve, reject) => {
    console.log(`::: [DEBUG] ${args.method} ${args.url}:`, 'loading', args)

    if (!['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].includes(args.method || '') || !args.url) {
      resolve(localResponseObj('Motivo: Carga inválida.', 0))
    }

    // Set HTTP request settings
    const xhr = new XMLHttpRequest()
    xhr.open(args.method, args.url)

    // Default header
    xhr.setRequestHeader('Content-Type', 'application/json')

    // Inserção de todos os headers do objeto
    for (const key in args.headers) {
      if (args.headers.hasOwnProperty(key)) {
        xhr.setRequestHeader(key, args.headers[key])
      }
    }

    // Sets a 90-second timeout (1 minute and 30 seconds)
    xhr.timeout = 90000

    // Process the server response
    xhr.onload = () => {
      let response = xhr.status !== 204 ? parseJson(xhr.responseText) : { code: 'OK', title: 'Feito!', message: '' }

      //console.log(`::: [DEBUG] ${args.method} ${args.url}:`, xhr.status || 'load', response || xhr.responseText)

      if (!response || !isHttpCodeValid(xhr.status)) {
        response = localResponseObj('Motivo: Resposta vazia ou inválida.')
      }

      resolve({ ...response, httpCode: xhr.status })
    }

    // Handle network failures or CORS-related issues
    xhr.onerror = () => {
      let response = parseJson(xhr.responseText)

      if (!response || !isHttpCodeValid(xhr.status)) {
        response = localResponseObj(`Motivo (error): ${xhr.statusText || 'Falha na rede ou erro desconhecido.'}`)
      }

      resolve({ ...response, httpCode: xhr.status || 0 })
    }

    // Handles the timeout case (when the response takes longer than 10s)
    xhr.ontimeout = () => {
      resolve(localResponseObj('Motivo: A solicitação demorou e foi cancelada.', xhr.status || 0))
    }

    // Send the HTTP request
    try
    {
      if (args.payload) {
        xhr.send(JSON.stringify(args.payload))
      } else {
        xhr.send()
      }
    }
    catch (e)
    {
      console.log(`::: [DEBUG] ${args.method} ${args.url}:`, 'Erro ao enviar requisição', e)

      resolve(localResponseObj(`Motivo (send): ${e.message || 'O envio falhou.'}`, xhr.status || 0))
    }
  })
}

//
//
//
// ABSTRAÇÃO DO HÁLLAN (ANALISAR MELHOR DEPOIS) - NOTA DO FERNANDO EM 12/03/25
//
//
//

/**
 * Cria uma instância da API com uma baseUrl personalizada.
 * @param {Object} config - Configuração inicial da API.
 * @param {string} config.baseUrl - URL base para as requisições.
 * @param {Object} [config.defaultHeaders={}] - Headers padrão para todas as requisições.
 * @returns {Object} - Retorna um objeto API com métodos HTTP (get, post, put, etc.).
 */
const apiRequest = (() => {
  const create = ({ baseUrl, defaultHeaders = {} }) => {
    /**
     * Faz uma requisição HTTP genérica.
     *
     * @param {'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'} method - Método HTTP.
     * @param {string} uri - Endpoint da API (relativo ou absoluto).
     * @param {Object|null} [payload=null] - Dados enviados na requisição.
     * @param {Object} [options={}] - Configurações adicionais (headers, etc.).
     * @returns {Promise<Object>} - Resposta da API.
     */
    const request = async (method, uri, payload = null, options = {}) => {
      try {
        const xhr = new XMLHttpRequest()
        const doesNotSupportBody = method === 'GET' || method === 'DELETE'

        // Se a URI não for absoluta (não começa com "http"), adicionamos a baseUrl
        if (!/^https?:\/\//.test(uri)) {
          // Garante que a URI começa com barra, se não, adiciona uma
          if (!uri.startsWith('/')) {
            uri = `/${uri}`
          }
          uri = `${baseUrl}${uri}`
        }

        // Adiciona query params se o método não suportar body
        if (doesNotSupportBody && payload) {
          const queryString = new URLSearchParams(payload).toString()
          const separator = uri.includes('?') ? '&' : '?'
          uri += `${separator}${queryString}`
        }

        xhr.open(method, uri)

        // Configurar headers padrões e extras
        const headers = { ...defaultHeaders, ...(options.headers || {}) }
        Object.entries(headers).forEach(([key, value]) => {
          xhr.setRequestHeader(key, value)
        })

        return await new Promise((resolve) => {
          xhr.onload = () => {
            let responseData
            try {
              responseData = JSON.parse(xhr.responseText) || {}
            } catch (error) {
              responseData = { code: 'LOCAL', title: 'Erro local', message: 'Resposta inválida' }
            }

            resolve(
              xhr.status >= 200 && xhr.status < 300
                ? responseData
                : { code: xhr.status, title: 'Erro HTTP', message: xhr.statusText, response: responseData }
            )
          }

          xhr.onerror = () => {
            resolve({ code: 'LOCAL', title: 'Erro local', message: 'Erro na rede ou CORS' })
          }

          xhr.send(doesNotSupportBody ? null : JSON.stringify(payload))
        })
      } catch (error) {
        return { code: 'LOCAL', title: 'Erro inesperado', message: error.message }
      }
    }

    /**
     * Método para fazer uma requisição GET.
     *
     * @param {string} uri - Endpoint da API.
     * @param {Object|null} [params=null] - Parâmetros de consulta (query params).
     * @param {Object} [options={}] - Configurações adicionais (como headers).
     * @returns {Promise<Object>} - Resposta da API.
     */
    const get = (uri, params = null, options = {}) => request('GET', uri, params, options)

    /**
     * Método para fazer uma requisição POST.
     *
     * @param {string} uri - Endpoint da API.
     * @param {Object|null} [payload=null] - Corpo da requisição.
     * @param {Object} [options={}] - Configurações adicionais (como headers).
     * @returns {Promise<Object>} - Resposta da API.
     */
    const post = (uri, payload = null, options = {}) => request('POST', uri, payload, options)

    /**
     * Método para fazer uma requisição PUT.
     *
     * @param {string} uri - Endpoint da API.
     * @param {Object|null} [payload=null] - Corpo da requisição.
     * @param {Object} [options={}] - Configurações adicionais (como headers).
     * @returns {Promise<Object>} - Resposta da API.
     */
    const put = (uri, payload = null, options = {}) => request('PUT', uri, payload, options)

    /**
     * Método para fazer uma requisição PATCH.
     *
     * @param {string} uri - Endpoint da API.
     * @param {Object|null} [payload=null] - Corpo da requisição.
     * @param {Object} [options={}] - Configurações adicionais (como headers).
     * @returns {Promise<Object>} - Resposta da API.
     */
    const patch = (uri, payload = null, options = {}) => request('PATCH', uri, payload, options)

    /**
     * Método para fazer uma requisição DELETE.
     *
     * @param {string} uri - Endpoint da API.
     * @param {Object|null} [params=null] - Parâmetros de consulta (query params).
     * @param {Object} [options={}] - Configurações adicionais (como headers).
     * @returns {Promise<Object>} - Resposta da API.
     */
    const deleteRequest = (uri, params = null, options = {}) => request('DELETE', uri, params, options)

    // Retorna os métodos HTTP
    return { get, post, put, patch, delete: deleteRequest }
  }

  return { create }
})()

const sosApi = apiRequest.create({
  baseUrl: apiUrl,
  defaultHeaders: { 'Content-Type': 'application/json' }
})

const sosReportApi = apiRequest.create({
  baseUrl: reportUrl,
  defaultHeaders: { 'Content-Type': 'application/json' }
})

const sosCloudFunctionsApi = apiRequest.create({
  baseUrl: cloudFunctionsUrl,
  defaultHeaders: { 'Content-Type': 'application/json' }
})

// Example to use:
// const responseSosReport = await sosReportApi.get('checkpayroll/-MLxYv1fZJrymAgUFJYU/-NhAdkNZ5XMDUX0jcL8q/01/02/2025/15/02/2025'); // http://localhost:8000/checkpayroll/-MLxYv1fZJrymAgUFJYU/-NhAdkNZ5XMDUX0jcL8q/01/02/2025/15/02/2025
// const responseSos = await sosApi.post('new_user', payload); // http://localhost:8000/api/new_user
// const responseGithub = await apiRequest.get('https://api.github.com/repos', { headers: { 'Authorization': `Bearer githubToken456` }}) // absolute url

axios.defaults.baseURL = apiUrl
axios.defaults.withCredentials = false

//
//
//
// EXPORTS
//
//
//

export {
  httpRequest,
  apiRequest,
  sosApi,
  sosReportApi,
  sosCloudFunctionsApi,
}
